import { VALIDATED_EXTENSION_FILE, WITHOUT_BUTTON } from "@constants";
import classNames from "classnames";
import PropTypes from "prop-types";

import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import { getFilenameFromUrl, getImageContentById } from "@helpers/general";

import { getProductTitle } from "@components/OrderTaking/Helpers";
import { imageWithFallback } from "@components/OrderTaking/Helpers/Commonfunction";
import { WithoutBasicComposition } from "@components/SvgIcons";

import { PadLockIcon } from "../../Icons/PadLockIcon";
import "./index.css";

export function ProductComposition({
    basicCompositionsIds,
    setSelectedBasicComposition,
    selectedBasicComposition = [],
    isValidateButtonActive,
    parentProductIuud,
}) {
    const { basicComposition, globalcard } = useSelector(
        (state) => state.orderSlice,
        shallowEqual
    );

    const { designItems } = useSelector(
        (state) => state.settingSlice,
        shallowEqual
    );
    const withoutButton = designItems.filter((item) => {
        return item.active === true && item.role === WITHOUT_BUTTON;
    });
    const withoutButtonContent = getImageContentById(withoutButton[0].id);

    const productCompositions = basicCompositionsIds.map((id) => {
        const image = getFilenameFromUrl(
            basicComposition[id].image,
            "catalog",
            "Items"
        );
        const productTitle = getProductTitle(basicComposition[id].name);
        const isRequired =
            globalcard?.items?.[parentProductIuud].basicComp[id]?.isObligatory;
        return { ...basicComposition[id], image, productTitle, isRequired };
    });
    function handleClick(id) {
        if (!setSelectedBasicComposition) {
            return;
        }
        setSelectedBasicComposition((prevSelected) => {
            const isSelected = prevSelected.includes(id);
            const newSelection = isSelected
                ? prevSelected.filter((item) => item !== id)
                : [...prevSelected, id];

            return newSelection;
        });
    }
    React.useEffect(() => {
        if (setSelectedBasicComposition) {
            setSelectedBasicComposition(selectedBasicComposition);
        }
    }, [basicCompositionsIds, selectedBasicComposition]);

    return (
        <div className="product-composition-container">
            {productCompositions.map((composition, index) => {
                return (
                    <div
                        key={index}
                        className="product-composition-item"
                        onClick={() => {
                            if (
                                isValidateButtonActive &&
                                !composition.isRequired
                            ) {
                                handleClick(composition.key);
                            }
                        }}
                    >
                        <div
                            className={classNames(
                                "d-flex justify-content-center align-items-center flex-column",
                                {
                                    "product-composition-img":
                                        !selectedBasicComposition.includes(
                                            composition.key
                                        ),
                                    "inactive-product-composition-img":
                                        selectedBasicComposition.includes(
                                            composition.key
                                        ),
                                }
                            )}
                            style={{
                                zIndex: 1,
                                position: "relative",
                                opacity: isValidateButtonActive ? "1" : "0.5",
                            }}
                        >
                            {selectedBasicComposition.includes(
                                composition.key
                            ) && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        zIndex: 2,
                                        backgroundSize: "unset",
                                        backgroundColor: "unset",
                                        opacity: "0.5",
                                    }}
                                >
                                    {VALIDATED_EXTENSION_FILE.includes(
                                        withoutButtonContent.slice(-4)
                                    ) ? (
                                        <img
                                            className="w-100 h-100"
                                            loading="lazy"
                                            id={`key-img${composition.key}`}
                                            src={withoutButtonContent}
                                            alt={"Without Basic Composition"}
                                            onError={imageWithFallback}
                                            style={{ objectFit: "cover" }}
                                        />
                                    ) : (
                                        <WithoutBasicComposition />
                                    )}
                                </div>
                            )}

                            <img
                                alt={composition.name}
                                src={composition.image}
                                style={{ height: "auto", width: "100%" }}
                            />
                            {composition.isRequired === true ? (
                                <div
                                    className="d-flex justify-content-end w-100"
                                    style={{
                                        width: "50px",
                                        height: "35px",
                                    }}
                                >
                                    <PadLockIcon />
                                </div>
                            ) : null}
                        </div>
                        <span
                            style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                fontFamily: "Segoe UI",
                                lineHeight: "1.2em",
                                textAlign: "center",
                                wordWrap: "break-word",
                                wordBreak: " break-word",
                                color: "black",
                            }}
                        >
                            {composition.productTitle}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}

ProductComposition.propTypes = {
    basicCompositionsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    setSelectedBasicComposition: PropTypes.any,
    selectedBasicComposition: PropTypes.arrayOf(PropTypes.string).isRequired,
    isValidateButtonActive: PropTypes.bool,
    parentProductIuud: PropTypes.string,
};
